"use strict";
exports.__esModule = true;
exports.MillenniumWeek = void 0;
var MillenniumDate_1 = require("./MillenniumDate");
var MillenniumDateTime_1 = require("./MillenniumDateTime");
var MillenniumWeekday_1 = require("./MillenniumWeekday");
var MillenniumWeek = /** @class */ (function () {
    function MillenniumWeek(aDateInWeek, firstDayOfWeek, daysInFirstWeek) {
        this.firstDayOfWeek = firstDayOfWeek;
        this.daysInFirstWeek = daysInFirstWeek;
        this.date = new MillenniumDate_1.MillenniumDate(this.getFirstDayNumberOfWeek(aDateInWeek));
        var keyDayNumber = this.date.getDayNumber();
        var dFW = daysInFirstWeek;
        if (keyDayNumber !== MillenniumDate_1.MillenniumDate.UNDEFINED_DAY_NUMBER &&
            keyDayNumber + 6 <= MillenniumDate_1.MillenniumDate.MAX_DAY_NUMBER) {
            keyDayNumber += 7 - dFW;
            var year = new MillenniumDate_1.MillenniumDate(keyDayNumber).getYear();
            var keyDayNumberFirstWeeek = this.getFirstDayNumberOfWeek(MillenniumDate_1.MillenniumDate.create(year, 1, dFW + 7)) - dFW;
            var week = Math.floor((keyDayNumber - keyDayNumberFirstWeeek) / 7) + 1;
            this._week = week; // Week without year
            this._weekWithYear = (year % 100) * 100 + week;
            if (this._weekWithYear.length < 4) {
                this._weekWithYear = "0".concat(this._weekWithYear);
            }
        }
        else {
            this._week = this._weekWithYear = MillenniumWeek.UNDEFINED_WEEK_NUMBER;
        }
    }
    MillenniumWeek.create = function (weekNumbers, firstDayOfWeek, daysInFirstWeek) {
        var returnArray = true;
        if (!Array.isArray(weekNumbers)) {
            weekNumbers = [weekNumbers];
            returnArray = false;
        }
        var result = [];
        var numWeeks = weekNumbers.length;
        var i, weekNumber;
        var tempWeek = new MillenniumWeek(MillenniumDate_1.MillenniumDate.today(), firstDayOfWeek, daysInFirstWeek);
        for (i = 0; i < numWeeks; i++) {
            weekNumber = weekNumbers[i];
            weekNumber = parseInt(weekNumber, 10);
            if (weekNumber > 200000) {
                weekNumber = weekNumber - 200000;
            }
            result.push(new MillenniumWeek(new MillenniumDate_1.MillenniumDate(tempWeek.weekNumberToDayNumber(weekNumber)), firstDayOfWeek, daysInFirstWeek));
        }
        return returnArray ? result : result[0];
    };
    MillenniumWeek.today = function (firstDayOfWeek, daysInFirstWeek) {
        return new MillenniumWeek(MillenniumDate_1.MillenniumDate.today(), firstDayOfWeek, daysInFirstWeek);
    };
    MillenniumWeek.toString = function (weeks, formatter) {
        if (formatter === void 0) { formatter = defaultFormatter; }
        if (!Array.isArray(weeks)) {
            return weeks.week();
        }
        var prevWeek = null;
        var groupedWeeks = [];
        weeks.forEach(function (week) {
            if (prevWeek && prevWeek.week() === week.addWeeks(-1).week()) {
                var prevPeriod = groupedWeeks[groupedWeeks.length - 1];
                if (Array.isArray(prevPeriod)) {
                    prevPeriod.push(week);
                }
                else {
                    groupedWeeks[groupedWeeks.length - 1] = [prevPeriod, week];
                }
            }
            else {
                // It used to be this. But it's probably wrong?? -> groupedWeeks.push(week);
                groupedWeeks.push([week]);
            }
            prevWeek = week;
        });
        return groupedWeeks
            .map(formatter)
            .filter(function (str) { return Boolean(str); })
            .join(", ");
    };
    MillenniumWeek.prototype.week = function (includeYear) {
        return this.getWeek(includeYear);
    };
    MillenniumWeek.prototype.getWeek = function (includeYear) {
        if (includeYear === void 0) { includeYear = true; }
        return includeYear ? this._weekWithYear : this._week;
    };
    MillenniumWeek.prototype.isSameWeekAs = function (other) {
        return this.week() === other.week();
    };
    MillenniumWeek.prototype.addWeeks = function (num) {
        return new MillenniumWeek(this.date.addDays(num * 7), this.firstDayOfWeek, this.daysInFirstWeek);
    };
    MillenniumWeek.prototype.weekNumberToDayNumber = function (weekNumber) {
        if (weekNumber >= MillenniumWeek.MIN_WEEK_NUMBER &&
            weekNumber <= MillenniumWeek.MAX_WEEK_NUMBER) {
            var year = Math.floor(weekNumber / 100);
            var week = weekNumber % 100;
            if (week === 1) {
                return this.getFirstDayNumberOfWeek(MillenniumDate_1.MillenniumDate.create(year, 1, this.getDaysInFirstWeek()));
            }
            var dayNumber = this.getFirstDayNumberOfWeek(MillenniumDate_1.MillenniumDate.create(year, 1, this.getDaysInFirstWeek() + 7));
            if (dayNumber !== MillenniumDate_1.MillenniumDate.UNDEFINED_DAY_NUMBER) {
                dayNumber += (week - 2) * 7;
                return dayNumber;
            }
        }
        return MillenniumDate_1.MillenniumDate.UNDEFINED_DAY_NUMBER;
    };
    MillenniumWeek.prototype.getStartDate = function () {
        return this.date;
    };
    /**
     * Return the date and time for the start of the week.
     *
     * @return {MillenniumDateTime} start of week
     */
    MillenniumWeek.prototype.getStartOfWeek = function () {
        return MillenniumDateTime_1.MillenniumDateTime.fromDate(this.date);
    };
    MillenniumWeek.prototype.getDateForWeekday = function (weekday) {
        var startOfWeek = this.getStartOfWeek();
        startOfWeek === null || startOfWeek === void 0 ? void 0 : startOfWeek.getMillenniumDate();
        var dateNumber = this.getStartOfWeek().getMillenniumDate().getDayNumber();
        dateNumber = dateNumber - this.firstDayOfWeek.getAbsoluteWeekdayNumber();
        dateNumber = dateNumber + weekday.getAbsoluteWeekdayNumber();
        return new MillenniumDate_1.MillenniumDate(dateNumber);
    };
    MillenniumWeek.prototype.getFirstDayNumberOfWeek = function (day) {
        if (!day) {
            return MillenniumDate_1.MillenniumDate.UNDEFINED_DAY_NUMBER;
        }
        if (day instanceof MillenniumDateTime_1.MillenniumDateTime) {
            day = day.getMillenniumDate();
        }
        if (!(day instanceof MillenniumDate_1.MillenniumDate)) {
            day = new MillenniumDate_1.MillenniumDate(day);
        }
        var dayNumber = day.getDayNumber();
        var weekdayNumber = this.getWeekdayNumber(day);
        if (dayNumber >= weekdayNumber) {
            return dayNumber - weekdayNumber;
        }
        return MillenniumDate_1.MillenniumDate.UNDEFINED_DAY_NUMBER;
    };
    MillenniumWeek.prototype.getDayOfWeek = function (date) {
        return (date.getDayNumber() + MillenniumWeekday_1.MillenniumWeekday.SATURDAY.getAbsoluteWeekdayNumber()) % 7;
    };
    MillenniumWeek.prototype.dayOfWeek2WeekdayNumber = function (dayOfWeek) {
        return (dayOfWeek + 7 - this.getFirstDayOfWeek().getAbsoluteWeekdayNumber()) % 7;
    };
    MillenniumWeek.prototype.getWeekdayNumber = function (aDate) {
        return this.dayOfWeek2WeekdayNumber(this.getDayOfWeek(aDate));
    };
    MillenniumWeek.prototype.getDaysInFirstWeek = function () {
        return this.daysInFirstWeek;
    };
    MillenniumWeek.prototype.getFirstDayOfWeek = function () {
        return this.firstDayOfWeek;
    };
    MillenniumWeek.prototype.weeksBetween = function (otherWeek) {
        return Math.abs(Math.floor((this.date.getDayNumber() - otherWeek.date.getDayNumber()) / 7));
    };
    MillenniumWeek.prototype.equals = function (obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumWeek)) {
            return false;
        }
        return this.getWeek(true) === obj.getWeek(true);
    };
    MillenniumWeek.UNDEFINED_WEEK_NUMBER = 0;
    MillenniumWeek.MIN_WEEK_NUMBER = 1;
    MillenniumWeek.MAX_WEEK_NUMBER = 6752;
    return MillenniumWeek;
}());
exports.MillenniumWeek = MillenniumWeek;
var defaultFormatter = function (period) {
    if (Array.isArray(period)) {
        return "".concat(period[0].week(), " - ").concat(period[period.length - 1].week());
    }
    return period.week();
};
